// extracted by mini-css-extract-plugin
module.exports = {"root":"loader_root__191m1","spin":"loader_spin__sUQMw","fixed":"loader_fixed__2TleL","absolute":"loader_absolute__34Ckq"};